import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Menu = _resolveComponent("Menu")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.loaded && _ctx.getPropertyBooleanValue(_ctx.MenuTypeConst.VISIBLE))
    ? _withDirectives((_openBlock(), _createBlock(_component_Menu, {
        key: 0,
        container: _ctx.container,
        id: _ctx.getPropertyValue(_ctx.MenuTypeConst.ID),
        style: _normalizeStyle(_ctx.getPropertyValue(_ctx.MenuTypeConst.STYLE)),
        class: _normalizeClass({ [_ctx.getPropertyValue(_ctx.MenuTypeConst.CLASS) ?? '']: true }),
        name: _ctx.getPropertyValue(_ctx.MenuTypeConst.NAME),
        disabled: _ctx.getPropertyBooleanValue(_ctx.MenuTypeConst.DISABLED),
        visible: _ctx.getPropertyBooleanValue(_ctx.MenuTypeConst.VISIBLE),
        placeholder: _ctx.getPropertyValue(_ctx.MenuTypeConst.PLACEHOLDER),
        model: _ctx.items,
        popup: _ctx.getPropertyBooleanValue(_ctx.MenuTypeConst.POPUP),
        appendTo: _ctx.getPropertyValue(_ctx.MenuTypeConst.APPENDTO),
        autoZIndex: _ctx.getPropertyBooleanValue(_ctx.MenuTypeConst.AUTOZINDEX),
        baseZIndex: _ctx.getPropertyNumberValue(_ctx.MenuTypeConst.BASEZINDEX),
        exact: _ctx.getPropertyBooleanValue(_ctx.MenuTypeConst.EXACT),
        tabindex: _ctx.getPropertyValue(_ctx.MenuTypeConst.TABINDEX),
        "aria-label": _ctx.getPropertyValue(_ctx.MenuTypeConst.ARIA_LABEL),
        "aria-labelledby": _ctx.getPropertyValue(_ctx.MenuTypeConst.ARIA_LABELLEDBY),
        ptOptions: _ctx.getPropertyValue(_ctx.MenuTypeConst.PTOPTIONS),
        unstyled: _ctx.getPropertyBooleanValue(_ctx.MenuTypeConst.UNSTYLED),
        modelValue: _ctx.vmodel,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.vmodel) = $event)),
        onClick: _ctx.clicktest
      }, _createSlots({
        start: _withCtx(() => [
          _renderSlot(_ctx.$slots, "start")
        ]),
        end: _withCtx(() => [
          _renderSlot(_ctx.$slots, "end")
        ]),
        itemicon: _withCtx((slotProps) => [
          _renderSlot(_ctx.$slots, "itemicon", {
            slotProps: { item: slotProps.item, class: slotProps.class, control: _ctx.ControlTypeConst.CTMENU }
          })
        ]),
        _: 2 /* DYNAMIC */
      }, [
        (_ctx.getLayoutComponent(_ctx.Component, _ctx.MenuTypeConst.LAYOUT_ITEM))
          ? {
              name: "item",
              fn: _withCtx((slotProps) => [
                _renderSlot(_ctx.$slots, "item", {
                  slotProps: { item: slotProps.item, control: _ctx.ControlTypeConst.CTMENU }
                })
              ]),
              key: "0"
            }
          : undefined
      ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["container", "id", "style", "class", "name", "disabled", "visible", "placeholder", "model", "popup", "appendTo", "autoZIndex", "baseZIndex", "exact", "tabindex", "aria-label", "aria-labelledby", "ptOptions", "unstyled", "modelValue", "onClick"])), [
        [_directive_tooltip, _ctx.getPropertyValue(_ctx.MenuTypeConst.TOOLTIP)]
      ])
    : _createCommentVNode("v-if", true)
}